import React, { Component } from "react";
import { Button, Badge, Collapse, UncontrolledTooltip } from 'reactstrap';
import { db, firebase } from '../firebase';
import PropTypes from 'prop-types';
import Iframe from 'react-iframe';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import * as routes from '../Constants/routes';


class Tournament extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      tournamentId: this.props.match.params.tournamentId,
      tournaments: this.context.tournaments,
      signedUp: false,
      checkedIn: false,
      participantId: "",
      tName: "",
      tDescription: "",
      tStart: "",
      tCheckIn: "",
      tCheckInStarted: false,
      tdisplayBUttons: true
    }

    this.signUp = this.signUp.bind(this);
    this.checkIn = this.checkIn.bind(this);
    this.cancelSignUp = this.cancelSignUp.bind(this);
    this.cancelCheckIn = this.cancelCheckIn.bind(this);
  }

  componentDidMount () {
    var url = this.state.tournamentId;
    var signedUp = _.find(this.state.tournaments, {"url": url })
    if (signedUp)
    {
      this.setState({signedUp: true})
      this.setState({participantId: signedUp.participantId})
    }

    var checkedIn = _.find(this.state.tournaments, {"url": url, "checkedIn": true })
    if (checkedIn)
    {
      this.setState({checkedIn: true})
    }

    if(this.props.location.state !== undefined)
    {
    var tList = this.props.location.state.tournaments;
    var theThis = this;

    tList.map(function(t, i){
      return (
        t.map(function(tourney, i){
          if (tourney.tournament.url == url){
              var dt=new Date(tourney.tournament.start_at);
              var checkInTime = new Date(dt);
              checkInTime.setMinutes(dt.getMinutes() - tourney.tournament.check_in_duration);
              var now = new Date();
              var checkinStarted = false;
              var displayButtons = true;
              if (now >= checkInTime && now <= dt ) {checkinStarted = true}

              if (now >= dt) {displayButtons = false}

              theThis.setState({
                tStart: dt.toLocaleString(),
                tCheckIn: checkInTime.toLocaleString(),
                tCheckInStarted: checkinStarted,
                tName: tourney.tournament.name,
                tDescription: tourney.tournament.description,
                tdisplayBUttons: displayButtons
              })
          }
        }))});
    } else {
      this.props.history.push({
        pathname: routes.TOURNAMENTGRID
      });
    }
  }

  signUp(event){
    var tUrl = this.state.tournamentId;
    var user = this.context.authUserId;
    var tourneyObj = this.state.tournaments;

    var url = 'https://us-central1-novablitzhq-api.cloudfunctions.net/challongeTournamentSignIn?tournamentId='
    + this.state.tournamentId + '&name=' + this.context.inGameName + '&email=' + this.context.authEmail

    fetch(url)
    .then(function(response) {
      return response.json();
    }).then(data => {

      tourneyObj.push({url: tUrl, checkedIn: false, deck: "", participantId: data.participant.id})

      db.updateUserTournaments(user, tourneyObj)
        .then(() => {
          this.setState(() => ({ signedUp: true, participantId: data.participant.id }));
      })

      alert("You are signed up, good luck!");
    });
  }

  cancelSignUp(event){
    var tUrl = this.state.tournamentId;
    var user = this.context.authUserId;
    var tourneyObj = this.state.tournaments;

    var url = 'https://us-central1-novablitzhq-api.cloudfunctions.net/challongeTournamentCancelSignIn?tournamentId='
    + this.state.tournamentId + '&participantId=' + this.state.participantId

    fetch(url)
    .then(function(response) {
      return response.json();
    }).then(data => {

        var updatedTournaments = tourneyObj.filter(function (d) {
            return (d.url != tUrl);
        });

      db.updateUserTournaments(user, updatedTournaments)
        .then(() => {
          this.setState(() => ({ signedUp: false, participantId: "", tournaments: updatedTournaments }));
      })

      alert("You are no longer signed up for the tournament.");
    });
  }

  checkIn(event){
    var tUrl = this.state.tournamentId;
    var user = this.context.authUserId;
    var tourneyObj = this.state.tournaments;

    var queryV = '?tournamentId=' + this.state.tournamentId + '&participantId=' + this.state.participantId;
    this.props.history.push({
      pathname: routes.DECKSELECT,
      search: queryV,
      state: {tournaments: tourneyObj}
    })
  }

  cancelCheckIn(event){
    var tUrl = this.state.tournamentId;
    var user = this.context.authUserId;
    var tourneyObj = this.state.tournaments;

    var url = 'https://us-central1-novablitzhq-api.cloudfunctions.net/challongeTournamentUndoCheckIn?tournamentId='
    + this.state.tournamentId + '&participantId=' + this.state.participantId

    fetch(url)
    .then(function(response) {
      return response.json();
    }).then(data => {
      _.forOwn(tourneyObj, function(value, key) {
        if (value.url == tUrl) {
                value.checkedIn = false;
          }
      });

      db.updateUserTournaments(user, tourneyObj)
        .then(() => {
          this.setState(() => ({ checkedIn: false }));
      })

      alert("You are no longer checked in for the tournament.");
    });
  }

  render() {

    var deckSectionStyle = {
      marginTop:75,
      justifyContent: "center",
      backgroundColor: "white"
    }

    var h2Style = {
      paddingLeft: 10,
      paddingTop: 5,
      fontFamily: "Audiowide, cursive",
      color: "cadetblue"
    };

    var paddingL = {
      paddingLeft: 10
    }

    if (this.state.tdisplayBUttons) {
        var visibleButtons = {
          visibility: "visible"
        }
      } else {
        var visibleButtons = {
          visibility: "hidden"
        }
      }


    return (
      <React.Fragment>
      <div className="Site-content">
      <div className="container" style={deckSectionStyle}>
      <h3 style={h2Style}>{this.state.tName}</h3>
      <h5 style={paddingL}>Start Time: {this.state.tStart}</h5>
      <h5 style={paddingL}>Check In Begins: {this.state.tCheckIn}</h5>
      <p style={paddingL} dangerouslySetInnerHTML={{__html: this.state.tDescription}}></p>
      <Button className="mr-1" style={visibleButtons} id="signUpButton" disabled={((this.context.authUser && !this.state.signedUp) ? false : true)} onClick={this.signUp}>Sign Up</Button>
      <Button className="mr-1" style={visibleButtons} id="checkInButton" disabled={((this.context.authUser && this.state.signedUp && !this.state.checkedIn && this.state.tCheckInStarted) ? false : true)} onClick={this.checkIn}>Check In</Button>
      <Button className="mr-1" style={visibleButtons} id="cancelSignUpButton" disabled={((this.context.authUser && this.state.signedUp) ? false : true)} onClick={this.cancelSignUp}>Cancel Sign Up</Button>
      <Button className="mr-1" style={visibleButtons} id="cancelCheckInButton" disabled={((this.context.authUser && this.state.signedUp && this.state.checkedIn) ? false : true)} onClick={this.cancelCheckIn}>Cancel Check In</Button>
      <Iframe url={"https://challonge.com/" + this.state.tournamentId + "/module?show_standings=1&show_final_results=1"}
              width="100%"
              height="500"
              id="myId"
              className="myClassname mt-1"
              display="initial"
              position="relative"
              allowFullScreen/>
      </div>
      </div>

      </ React.Fragment>
    );
  }
}

Tournament.contextTypes = {
authUser: PropTypes.object,
userName: PropTypes.string,
inGameName: PropTypes.string,
displayIGN: PropTypes.bool,
authUserId: PropTypes.string,
favorites: PropTypes.array,
authEmail: PropTypes.string,
tournaments: PropTypes.array
};

export default Tournament;



// WEBPACK FOOTER //
// ./src/Tournaments/Tournament.js